/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"

export const selectionWrapCss = css`
  border: 1px solid #dbdbdb;
  border-radius: 8px;
`
export const textCommonCss = css`
  color: #1a1a1a;
  font-size: 16px;
`

export const checkboxGroupWrapCss = css`
  padding: 24px;
`

export const checkboxGroupCss = css`
  display: flex;
  flex-direction: column;
  // 70 modal header, 60 text above checkbox group , 84 checkAll checkbox, 84 footer, 48 padding, 50 padding bottom
  max-height: calc(100vh - 70px - 60px - 84px - 84px - 48px - 50px);
  overflow: auto;
  flex-wrap: nowrap;

  > label {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const checkAllRowWrap = css`
  border-bottom: 1px solid #dbdbdb;
  padding: 16px 24px;
`

export const checkAllOption = css`
  display: flex;
  align-items: center;
`

export const formInputCss = css`
  .ant-form-item-control-wrapper {
    .ant-form-item-control {
      input {
        width: 205px;
        height: 38px;
      }
    }
  }
`
